import React, { useCallback } from "react";
import PropTypes from "prop-types";

// components
import Template from "../Template.js";
import FormSelectDialog from "core/FormSelectDialog";

// styles
import { ModeratorStyled } from "./styles";

// utils
import * as Utils from "./utils.js";

const Moderator = ({
    batchId,
    onModeratorSelect,
    moderator,
    moderators = [],
    currentUser,
    isEditable = true
}) => {
    const onSelect = chosenModerator => {
        onModeratorSelect(chosenModerator.id);
    };

    // get options
    const getOptions = useCallback(
        () => Utils.getOptions(moderators, currentUser),
        [moderators]
    );

    const options = getOptions();

    const getSelectedOption = useCallback(
        () => Utils.getSelectedOption(moderator, options),
        [options, moderator]
    );

    const selectedOption = getSelectedOption();

    return (
        <Template title="Mod" titleFull="Moderators" width={200}>
            <ModeratorStyled data-testid="batch-moderator">
                <FormSelectDialog
                    id={`form-select-moderator-${batchId}`}
                    dialogAlignment="left"
                    controlHeight={25}
                    controlWidth="200px"
                    dialogWidth="250px"
                    dialogZIndex={75}
                    options={options}
                    selectedOption={selectedOption}
                    setSelectedOption={onSelect}
                    controlType="edit"
                    isDisabled={!isEditable}
                />
            </ModeratorStyled>
        </Template>
    );
};

export default Moderator;

// prop-types
Moderator.propTypes = {
    batchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    onModeratorSelect: PropTypes.func.isRequired,
    moderator: PropTypes.object,
    moderators: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    isEditable: PropTypes.bool
};
